/* global $ */
import React, { useState, useEffect, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';

const BatchNo = () => {
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [newRecord, setNewRecord] = useState({
        batch_no: "",
        batch_status: "",
        batch_date: "",
        city_name: "",
    });
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab');
                setData(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const handleModalClose = () => {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            $('body').css({
                'padding-right': '',
                'overflow': ''
            });

            $('.content-wrapper').css('min-height', 'calc(100vh - 114px)');
        };

        $('#editRowModal').on('hidden.bs.modal', handleModalClose);
        return () => $('#editRowModal').off('hidden.bs.modal', handleModalClose);
    }, []);

    const handleDelete = useCallback(async (mas_id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });
        if (result.isConfirmed) {
            try {
                await axios.delete(`https://api.eazyworldehsengineering.com/api/batchno_tab/${mas_id}`);
                Swal.fire('Deleted!', 'The record has been deleted.', 'success');
                setData(data.filter(item => item.mas_id !== mas_id));
            } catch (error) {
                console.error('Error deleting data:', error);
                Swal.fire('Error!', 'There was an issue deleting the record.', 'error');
            }
        }

    }, [data]);

    const convertToYYYYMMDD = (dateStr) => {
        const date = new Date(dateStr);
        if (isNaN(date)) return ""; // Return empty if date is invalid
        return date.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
    };

    const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date);
    };

    function formatDate(dateStr) {
        if (!dateStr) return ''; // Return empty string if dateStr is undefined or empty

        const date = new Date(dateStr); // Convert date string to Date object

        return date.toLocaleDateString('en-GB', {
            day: 'numeric',    // 10
            month: 'numeric',    // Mar
            year: 'numeric'    // 2024
        });
    }

    const handleEdit = async (row) => {

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to edit this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, edit it!',
        });

        if (result.isConfirmed) {
            setSelectedRow(row);
            setNewRecord({
                batch_no: row.batch_no,
                batch_status: row.batch_status,
                batch_date: isValidDate(new Date(row.batch_date)) ? convertToYYYYMMDD(row.batch_date) : "",
                city_name: row.city_name,
            });
            $('#editRowModal').modal('show');
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        if (!selectedRow) return;
        // Format the date to 'YYYY-MM-DD'

        // Ask for confirmation before proceeding with the edit
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to save the changes?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, save it!'
        });

        if (result.isConfirmed) {

            const updatedData = {
                mas_id: selectedRow.mas_id,
                batch_no: newRecord.batch_no,
                batch_status: newRecord.batch_status,
                batch_date: isValidDate(new Date(newRecord.batch_date)) ? convertToYYYYMMDD(newRecord.batch_date) : "",
                city_name: newRecord.city_name,
            };

            try {
                await axios.put(`https://api.eazyworldehsengineering.com/api/batchno_tab/${selectedRow.mas_id}`, updatedData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }

                });
                setData(data.map(item => item.mas_id === selectedRow.mas_id ? updatedData : item));
                $('#editRowModal').modal('hide');
                Swal.fire('Saved!', 'The record has been updated.', 'success');
            } catch (error) {
                console.error('Error updating data:', error);
                Swal.fire('Error!', 'There was an issue updating the record.', 'error');
            }
        }

    };

    const handleCreateSubmit = async (event) => {
        event.preventDefault();

        const newRecordData = {
            batch_no: newRecord.batch_no,
            batch_status: newRecord.batch_status,
            batch_date: newRecord.batch_date,
            city_name: newRecord.city_name,
        };

        try {
            const response = await axios.post('https://api.eazyworldehsengineering.com/api/batchno_tab/', newRecordData, {
                headers: {
                    'Content-Type': 'application/json',
                }

            });

            $('#addRowModal').modal('hide').on('hidden.bs.modal', function () {
                // Ensure backdrop is removed correctly by Bootstrap
                setTimeout(() => {
                    $('body').removeClass('modal-open');// Ensure body class is reset
                    $('.modal-backdrop').remove();
                    $('body').css('padding-right', ''); // Reset any padding added by Bootstrap to compensate for scrollbar

                    // Re-enable scrolling
                    $('body').css('overflow', '');
                }, 500); // Wait for a short time to let Bootstrap handle transitions
            });

            // Update the DataTable with the new record
            setData(prevData => [...prevData, response.data]);

            setNewRecord({
                batch_no: "",
                batch_status: "",
                batch_date: "",
                city_name: "",
            });

            await Swal.fire('Created!', 'The record has been Created.', 'success');
        } catch (error) {
            console.error('Error creating new record:', error);
            Swal.fire('Error!', 'There was an issue on creating the record.', 'error');
        }
    };

    const handleAddButtonClick = () => {
        setNewRecord({
            batch_no: "",
            batch_status: "",
            batch_date: "",
            city_name: "",
        });
        $('#addRowModal').modal('show');
    };


    const handleInputChange = (event) => {
        const { id, value } = event.target;
        setNewRecord(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const filteredData = data.filter(item =>
        item.batch_no.toLowerCase().includes(searchText.toLowerCase()) ||
        item.batch_status.toLowerCase().includes(searchText.toLowerCase()) ||
        item.batch_date.toLowerCase().includes(searchText.toLowerCase()) ||
        item.city_name.toLowerCase().includes(searchText.toLowerCase())
    );

    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Mas ID</span>,
            selector: row => row.mas_id,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Batch No</span>,
            selector: row => row.batch_no,
            sortable: true,
            width: '200px',
            style: {
                fontWeight: '500' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>City</span>,
            selector: row => row.city_name,
            sortable: true,
            width: '250px',
            style: {
                fontWeight: '500' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Batch Status</span>,
            selector: row => row.batch_status,
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '500' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Batch ON Date</span>,
            selector: row => formatDate(row.batch_date),
            width: '150px',
            sortable: true,
            style: {
                fontWeight: '500' // Makes the font bold
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div>
                    <button onClick={() => handleEdit(row)} className="btn btn-primary btn-sm" style={{ marginRight: '8px' }}><i className="fa fa-edit"></i></button>
                    <button onClick={() => handleDelete(row.mas_id)} className="btn btn-danger btn-sm"><i className="fa fa-times"></i></button>
                </div>
            ),
            width: '150px'
        }
    ];

    return (
        <div className="content-wrapper">
            {/* Page Header */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Batch No</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Batch No</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Button */}
            <div className="row mb-3 px-3">
                <div className="col text-right">
                    <button
                        className="btn btn-primary"
                        onClick={handleAddButtonClick}
                        data-bs-toggle="modal"
                        data-bs-target="#addRowModal"
                    >
                        <i className="fa fa-plus mr-1"></i> Add New
                    </button>
                </div>
            </div>

            {/* Data Table */}
            <section className="content px-3">
                <div className="card">
                    <div className="card-body">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="form-control mb-3"
                        />
                        <DataTable
                            columns={columns}
                            data={filteredData}
                            pagination
                            paginationPerPage={100}
                            paginationRowsPerPageOptions={[100, 200, 300]}
                        />

                        {/* Edit Modal */}
                        <div className="modal fade" id="editRowModal">
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <form onSubmit={handleFormSubmit}>
                                        <div className="modal-header bg-primary">
                                            <h4 className="modal-title text-white">Edit Batch No</h4>
                                            <button type="button" className="close text-white" data-dismiss="modal">
                                                <span>&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className="col-md-6 form-group">
                                                    <label>Batch No</label>
                                                    <input
                                                        id="batch_no"
                                                        type="text"
                                                        className="form-control"
                                                        value={newRecord.batch_no}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <label>City</label>
                                                    <input
                                                        id="city_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={newRecord.city_name}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <label>Batch Status</label>
                                                    <select
                                                        className="form-control"
                                                        id="batch_status"
                                                        value={newRecord.batch_status}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Active">Active</option>
                                                        <option value="Inactive">Inactive</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <label>Batch On Date</label>
                                                    <input
                                                        id="batch_date"
                                                        type="date"
                                                        className="form-control"
                                                        value={newRecord.batch_date}
                                                        onChange={(e) =>
                                                            setNewRecord(prevState => ({
                                                                ...prevState,
                                                                batch_date: e.target.value
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer justify-content-between">
                                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                            <button type="submit" className="btn btn-primary">Save Changes</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Add Modal */}
                        <div className="modal fade" id="addRowModal">
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <form onSubmit={handleCreateSubmit}>
                                        <div className="modal-header bg-success">
                                            <h4 className="modal-title text-white">Add Batch No</h4>
                                            <button type="button" className="close text-white" data-dismiss="modal">
                                                <span>&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className="col-md-6 form-group">
                                                    <label>Batch No</label>
                                                    <input
                                                        id="batch_no"
                                                        type="text"
                                                        className="form-control"
                                                        value={newRecord.batch_no}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <label>City</label>
                                                    <input
                                                        id="city_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={newRecord.city_name}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <label>Batch Status</label>
                                                    <select
                                                        className="form-control"
                                                        id="batch_status"
                                                        value={newRecord.batch_status}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Active">Active</option>
                                                        <option value="Inactive">Inactive</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-6 form-group">
                                                    <label>Batch On Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={newRecord.batch_date}
                                                        onChange={(e) =>
                                                            setNewRecord(prev => ({
                                                                ...prev,
                                                                batch_date: e.target.value
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer justify-content-between">
                                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                            <button type="submit" className="btn btn-success">Add</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );

};

export default BatchNo;
